import { render, staticRenderFns } from "./ScrollLink.vue?vue&type=template&id=4d824da0&scoped=true&"
import script from "./ScrollLink.vue?vue&type=script&lang=js&"
export * from "./ScrollLink.vue?vue&type=script&lang=js&"
import style0 from "./ScrollLink.vue?vue&type=style&index=0&id=4d824da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d824da0",
  null
  
)

export default component.exports